import React, { useState } from 'react';
import { Section } from '../components/Section';
import { Faq } from '../components/Faq';
import { faqsContact } from '../data/faqsContact';
import { CONTACT_EMAIL, DEMO_URL, FORM_ENDPOINT, SIGN_IN_URL } from '../data/links';
const VERTICALS = ['Pharma', 'Financial services', 'Insurance', 'Legal', 'Other'];
const NEXT = [{
  t: 'We compile your workflow.',
  b: 'Your obligations, put in front of the model, on the request you named.'
}, {
  t: 'You see the receipt.',
  b: 'Which rules went in, which versions, on what trigger. Signed.'
}, {
  t: 'A 30-minute walkthrough.',
  b: 'Where it fits, and where it doesn’t. If it’s not for you, we’ll say so.'
}];
type Status = 'idle' | 'sending' | 'sent' | 'error';
export function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [vertical, setVertical] = useState<string | null>(null);
  const [workflow, setWorkflow] = useState('');
  const [status, setStatus] = useState<Status>('idle');
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const fields = {
      name,
      email,
      vertical: vertical ?? '—',
      workflow,
      _subject: `Synthia contact — ${name.trim() || 'no name'}${vertical ? ` (${vertical})` : ''}`
    };
    setStatus('sending');
    try {
      const res = await fetch(FORM_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(fields)
      });
      if (!res.ok) throw new Error(String(res.status));
      setStatus('sent');
      setName('');
      setEmail('');
      setVertical(null);
      setWorkflow('');
    } catch {
      setStatus('error');
    }
  };
  return <>
      <Section n="01" label="Start here" id="contact" noTop contentClassName="page-hero contact-c" data-id="element-380" data-mp="10hncv4tq6r3i">
        <div className="hgroup" style={{
        gap: 22
      }} data-id="element-381" data-mp="26w66px9eq0u9">
          <h1 className="h1" style={{
          maxWidth: 760
        }} data-id="element-382" data-mp="2buzi9k54vhrs">
            Bring your highest standards.
          </h1>
          <p className="lede" style={{
          maxWidth: 610
        }} data-id="element-383" data-mp="1m6bzv75tuox4">
            Tell us the workflow where being wrong costs the most.
          </p>
        </div>

        <div className="contact-g" data-id="element-384" data-mp="1hamvmqiv4juh">
          {status === 'sent' ? <div className="sent" role="status" data-id="element-385" data-mp="1w519kcnkl32a">
              <div className="t" data-id="element-386" data-mp="1r6q0w590gyln">Thanks. It’s with us.</div>
              <p data-id="element-387" data-mp="1r785pq9qol56">We’ll reply within one business day, usually with a question or two about the workflow.</p>
              <button type="button" className="btn btn-o" onClick={() => setStatus('idle')} data-id="element-388" data-mp="13erhexzerwxf">
                Send another
              </button>
            </div> : <form className="cform" onSubmit={submit} data-id="element-389" data-mp="1d88d67j3vm3q">
              <label className="fld" data-id="element-390" data-mp="18ff81ijq6br4">
                <span className="fl" data-id="element-391" data-mp="18edzbkq6m1ck">NAME</span>
                <input className="inp" type="text" required autoComplete="name" value={name} onChange={e => setName(e.target.value)} data-id="element-392" data-mp="kq4gmro9ltpn" />
              </label>
              <label className="fld" data-id="element-393" data-mp="fr1b764dhlh5">
                <span className="fl" data-id="element-394" data-mp="2rewqlw264k0t">WORK EMAIL</span>
                <input className="inp" type="email" name="email" required autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} data-id="element-395" data-mp="2rd262iut6tx9" />
              </label>
              <div className="fld" data-id="element-396" data-mp="2hhiajxk5px91">
                <span className="fl" id="vert-l" data-id="element-397" data-mp="2hedxsbsmlt6r">
                  VERTICAL
                </span>
                <div className="vchips" role="group" aria-labelledby="vert-l" data-id="element-398" data-mp="2mdh4s1s629hd">
                  {VERTICALS.map(v => <button key={v} type="button" className={`vchip${vertical === v ? ' on' : ''}`} aria-pressed={vertical === v} onClick={() => setVertical(vertical === v ? null : v)} data-id="element-399" data-mp="3f47foga5opz4">
                      {v}
                    </button>)}
                </div>
              </div>
              <label className="fld" data-id="element-400" data-mp="1trxp980j6nwl">
                <span className="fl" data-id="element-401" data-mp="1torzdqk2vhzt">THE WORKFLOW</span>
                <textarea className="inp" required placeholder="I have to respond to compliance findings, and every draft comes back with something missing…" value={workflow} onChange={e => setWorkflow(e.target.value)} data-id="element-402" data-mp="29yal7rvpfgub" />
              </label>
              <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 16,
            flexWrap: 'wrap'
          }} data-id="element-403" data-mp="1v71t9c4bxje0">
                <button type="submit" className="btn btn-s" style={{
              height: 48,
              padding: '0 22px'
            }} disabled={status === 'sending'} data-id="element-404" data-mp="2suskqvgsol14">
                  {status === 'sending' ? 'Sending…' : 'Send message'}
                </button>
                {status === 'error' && <span className="ferr" role="alert" data-id="element-405" data-mp="2ewkic80zorik">
                    That didn’t go through. Try again, or email <a href={`mailto:${CONTACT_EMAIL}`} data-id="element-406" data-mp="17l3nlntejqkq">{CONTACT_EMAIL}</a>.
                  </span>}
              </div>
            </form>}

          <aside className="reach" id="demo" data-id="element-407" data-mp="3f63fz4ujdc77">
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 12
          }} data-id="element-408" data-mp="3f7516259nf2n">
              <div className="eyebrow" data-id="element-409" data-mp="3j7f93kcmcfk5">BOOK A DEMO</div>
              <div className="t" data-id="element-410" data-mp="3o68mzdvti8ku">Or skip the form.</div>
              <div className="b" data-id="element-411" data-mp="3o4nuruwz71q5">
                Thirty minutes on a workflow you actually care about. We compile it, you read the receipt, and if it isn’t a fit we’ll tell you.
              </div>
              <div data-id="element-412" data-mp="1q4grzbwxok7">
                <a className="btn" href={DEMO_URL} target="_blank" rel="noopener" style={{
                border: '1px solid var(--ink)'
              }} data-id="element-413" data-mp="1sqjnlnuzfw3">
                  Schedule a demo
                </a>
              </div>
            </div>
            <div className="reach-l" data-id="element-414" data-mp="fpx37igepimd">
              <div data-id="element-415" data-mp="fovrdbrkgs3l">
                <div className="eyebrow" data-id="element-416" data-mp="fpdu8r8qi4kh">EMAIL US</div>
                <a href={`mailto:${CONTACT_EMAIL}`} data-id="element-417" data-mp="2cj8mpfxh7f3s">{CONTACT_EMAIL}</a>
              </div>
              <div data-id="element-418" data-mp="2hh0d25ih2t5v">
                <div className="eyebrow" data-id="element-419" data-mp="2hil77u0vka37">TALK TO SALES</div>
                <a href="mailto:sales@meetsynthia.ai" data-id="element-420" data-mp="3ksfwnzo82zpw">sales@meetsynthia.ai</a>
              </div>
              <div data-id="element-421" data-mp="3ftcq2aslglft">
                <div className="eyebrow" data-id="element-422" data-mp="3ftw6to6id3s9">ALREADY A CUSTOMER</div>
                <a href={SIGN_IN_URL} target="_top" rel="noopener" data-id="element-423" data-mp="3fvpg7b8ia23y">
                  app.meetsynthia.ai
                </a>
              </div>
            </div>
          </aside>
        </div>
      </Section>

      <Section n="02" label="What happens next" data-id="element-424" data-mp="3owdrvzaffqdo">
        <h2 className="h2" data-id="element-425" data-mp="7kmki4kuthi2">
          Rent the model.
          <br data-id="element-426" data-mp="2mugic6xq4xi" />
          Own the instructions.
        </h2>
        <ol className="nextl" data-id="element-427" data-mp="2mb8pob00wx7">
          {NEXT.map((s, i) => <li key={s.t} data-id="element-428" data-mp="gehfwkw6btki" data-mpi={i}>
              <span className="k" data-id="element-429" data-mp="gdpug2wajc7y">{String(i + 1).padStart(2, '0')}</span>
              <span data-id="element-430" data-mp="cce1bne7k8v0">
                <strong data-id="element-431" data-mp="cd5xp0fmqamc">{s.t}</strong> <span style={{
              color: 'var(--mut)'
            }} data-id="element-432" data-mp="ceqs8q1y1tk7">{s.b}</span>
              </span>
            </li>)}
        </ol>
      </Section>

      <Section n="03" label="FAQ" data-id="element-433" data-mp="ldua5qpdk2x4">
        <h2 className="h2" data-id="element-434" data-mp="levny2xrz3ij">Asked and answered.</h2>
        <div style={{
        maxWidth: 820
      }} data-id="element-435" data-mp="14zdros9rs0mk">
          <Faq items={faqsContact} data-id="element-436" data-mp="150fdnrsbq7j2" />
        </div>
      </Section>
    </>;
}